import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
export type UserFragmentFragment = { __typename?: 'User', id: number, email: string, name: string, imageUrl?: string | null, pipedriveId?: string | null, salesforceId?: string | null, salesforceUrl?: string | null, jobTitle?: string | null, locale?: string | null, podId?: number | null, active: boolean, isRobot: boolean, phone?: string | null, birthday?: string | null, comment?: string | null, rfqLimit?: number | null, region?: Types.UserRegionEnum | null, couponLimit: number, roles: Array<{ __typename?: 'Role', id: number, name: string }>, autoAssignmentSettings?: { __typename?: 'AutoAssignmentSettings', customerOrderGrade?: Array<Types.CustomerOrderGradeEnum> | null, languages?: Array<Types.LanguageEnum> | null, maxDeals?: number | null, overloadPossible?: boolean | null, technology?: Array<number> | null } | null, substitutedBy?: Array<{ __typename?: 'OmsSubstitution', createdAt: string, endDate: string, id: number, startDate: string, deputyUser: { __typename?: 'User', name: string, id: number }, user: { __typename?: 'User', name: string, id: number } }> | null, substitutedByArchived?: Array<{ __typename?: 'OmsSubstitution', createdAt: string, endDate: string, id: number, startDate: string, deputyUser: { __typename?: 'User', name: string, id: number }, user: { __typename?: 'User', name: string, id: number } }> | null, substitutingFor?: Array<{ __typename?: 'OmsSubstitution', createdAt: string, endDate: string, id: number, startDate: string, deputyUser: { __typename?: 'User', name: string, id: number }, user: { __typename?: 'User', name: string, id: number } }> | null, substitutingForArchived?: Array<{ __typename?: 'OmsSubstitution', createdAt: string, endDate: string, id: number, startDate: string, deputyUser: { __typename?: 'User', name: string, id: number }, user: { __typename?: 'User', name: string, id: number } }> | null };

export const UserFragmentFragmentDoc = gql`
    fragment userFragment on User {
  id
  email
  name
  imageUrl
  pipedriveId
  salesforceId
  salesforceUrl
  jobTitle
  locale
  podId
  active
  isRobot
  phone
  birthday
  comment
  rfqLimit
  region
  roles {
    id
    name
  }
  autoAssignmentSettings {
    customerOrderGrade
    languages
    maxDeals
    overloadPossible
    technology
  }
  substitutedBy {
    createdAt
    deputyUser {
      name
      id
    }
    user {
      name
      id
    }
    endDate
    id
    startDate
  }
  substitutedByArchived {
    createdAt
    deputyUser {
      name
      id
    }
    user {
      name
      id
    }
    endDate
    id
    startDate
  }
  substitutingFor {
    createdAt
    deputyUser {
      name
      id
    }
    user {
      name
      id
    }
    endDate
    id
    startDate
  }
  substitutingForArchived {
    createdAt
    deputyUser {
      name
      id
    }
    user {
      name
      id
    }
    endDate
    id
    startDate
  }
  couponLimit
}
    `;